<nav class="tu-nav-tabbar navbar navbar-expand-lg navbar-light" [attr.aria-label]="'content.primary-website-areas' | translate" role="navigation" [hidden]="!displayTabBar">
  <div class="container">
    <ul class="tu-nav-tabbar nav nav-pills">
      @if (canViewAdmin) {
        <li class="nav-item">
          <a class="nav-link"
            routerLink="/admin"
            [attr.aria-label]="'content.go-to-the-admin-page' | translate"
            [ngClass]="{active: isActive('/admin')}">
            {{ 'content.administration' | translate }}
          </a>
        </li>
      }
      @if (canViewBusiness) {
        <li class="nav-item">
          <a class="nav-link"
            routerLink="/business-services"
            [attr.aria-label]="'content.go-to-the-business-page' | translate"
            [ngClass]="{active: isActive('/business-services')}">
            {{ 'content.business-services' | translate }}
          </a>
        </li>
      }
      @if (canViewConsumer) {
        <li class="nav-item">
          <a class="nav-link"
            routerLink="/consumer-services"
            [attr.aria-label]="'content.go-to-the-consumer-page' | translate"
            [ngClass]="{active: isActive('/consumer-services')}">
            {{ 'content.consumer-services' | translate }}
          </a>
        </li>
      }
    </ul>
    @if (!!guideKey && !!guideName) {
      <button class="tu-link" (click)="displayGuide(guideKey)">{{ guideName }}</button>
    }
  </div>
</nav>
